import React from 'react';
import ScreenWrapper from '../../../commons/ScreenWrapper';
import MailTemplateForm from '../../../layouts/Admin/Plans/MailTemplateForm';

const MailTemplateCreatePage = ({
    match,
    title
}) => {
    const { offer_identifier } = match && match.params ? match.params : {};
    const [showSendTestMainBtn, setShowSendTestMainBtn] = React.useState(false)

    return (
        <ScreenWrapper
            pageTitle={title}
            hasForm
        >
            <MailTemplateForm match={match} readOnly={false} offer_identifier={offer_identifier} showSendTestMainBtn={showSendTestMainBtn} setShowSendTestMainBtn={setShowSendTestMainBtn} />
        </ScreenWrapper>
    )
}

export default MailTemplateCreatePage